import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/apps/web/modules/auth/login/components/login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
